export default "__VITE_ASSET__d19fc134__"